
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(4(5(13|79|9)|021|13|290|422|479|617|720|734|8|982)|2((05|47|61)9|133|146|225|266|518|553|754|794|840)|5(5(11|83|9)|6(37|4|91)|3([017]9|78)|96[36]|152|406|726|854)|6(4(19|48|94)|(53|56|61)8|02|034|303|370|732|86)|1(7(15|33|89)|04|31|58|657)|8(4(18|30|6)|(09|15|55|73)4|(2|92|99)2|025|278|63|666)|7((05|3|99)8|(20|65|79|83)3|195|322|531|547|632)|3(5(05|35|91)|7(21|74|81)|9(18|2|43)|[02]30|09|14|266|334|37|443|697)|9(9(|14|98)|046|166|280|4|457|614|650))$/.test(chunkId);
},
rootOutputDir: "",

    };
}
